import React from "react";
import { Link } from "react-router-dom";
import { Mail, Github, Linkedin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-slate-100 border-t border-gray-200 mt-16">
      {/* ===== COPYRIGHT BAR ===== */}
      <div className="border-t border-gray-200 bg-slate-50 py-4">
        <div className="max-w-9xl mx-auto px-7 flex flex-col md:flex-row items-center justify-between text-sm text-gray-500">
          <p>© {new Date().getFullYear()} Origenomi. All rights reserved.</p>
          <p className="mt-2 md:mt-0">
            <span className="text-green-600">Ori</span>
            <span className="text-purple-500">genomi</span> is free to use for everybody, even commercially. See our{" "}
            <Link to="/license" className="text-emerald-700 hover:underline font-medium">
              license
            </Link>{" "}
            for details.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
